export default {
  DOLLAR_TYPE: 'dollar_type',
};
